import React from 'react';
import Message from '@uds/message';
import CallToAction from 'components/common/CallToAction';
import { Kind } from '@uds/button';
import ProductPrice from 'components/common/ProductPrice';
import { useBreakpoints } from '@ux/responsive';
import { CTA } from 'core/ribbons/cta';
import { Product } from '@uds/product';
import { PricingStrategy } from 'presentation/components/common/ProductPrice/constants';
import { isNilOrEmpty } from 'presentation/utils/generalUtils';

import useStylesheet from './ItemPrice.stylesheet';

interface OuterProps {
  ctas?: Array<CTA>;
  index: number;
  id: string | number;
  product: Product;
  pricingStrategy: PricingStrategy;
}

const PureSalesboardItemPrice = ({ ctas = [], product, pricingStrategy, id, index }: OuterProps) => {
  const ctaProps = JSON.parse(JSON.stringify(ctas[0] || {}));
  ctaProps.kind = Kind.PRIMARY;
  const { isMinSm, isMinLg } = useBreakpoints();
  const { styles } = useStylesheet({ isMinLg });
  return (
    <div>
      <div style={styles.body}>
        <ProductPrice product={product} pricingStrategy={pricingStrategy} showLegalCaveat={false} />
      </div>
      {!isNilOrEmpty(ctas[0]) && (
        <div style={styles.cta}>
          <CallToAction
            product={product}
            ribbonId={id as string}
            index={index}
            block={!isMinSm}
            glyph="arrowRight"
            data-selector="salesboard-item-cta"
            label={<Message id="usf.salesboard.item.select" />}
            {...ctaProps}
          />
        </div>
      )}
    </div>
  );
};

PureSalesboardItemPrice.displayName = 'SalesboardItemPrice';

export default PureSalesboardItemPrice;
